import { FocusEvent } from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { getTranslatedInitialValue } from 'helpers/getTranslatedInitialValue';

import { TextInput } from '../TextInput';
import { ITextFieldProps } from '../TextInput/types';

import styles from './TextInputControl.module.scss';

export const TextInputControl = <T extends FieldValues>(props: UseControllerProps<T> & ITextFieldProps) => {
  const { name, control, rules, defaultValue, onBlur, maxLength, ...restProps } = props;

  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const { ref, value, onBlur: onFieldBlur, onChange, ...restField } = field;
  const { error } = fieldState;

  const valueToShow = restProps.disabled ? getTranslatedInitialValue(value) : value;

  const handleBlur = (e?: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onFieldBlur();

    if (onBlur && e) onBlur(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (!inputValue) {
      onChange('');
      return;
    }

    if (rules?.pattern) {
      const pattern = (rules.pattern as { value: RegExp }).value ?? rules.pattern;
      if (!pattern.test(inputValue)) {
        return;
      }
    }

    onChange(inputValue);
  };

  return (
    <TextInput
      inputRef={ref}
      value={valueToShow ?? ''}
      fieldError={error}
      onBlur={handleBlur}
      onChange={handleChange}
      maxLength={maxLength}
      fieldClassName={styles.wrapper}
      {...restField}
      {...restProps}
    />
  );
};
